<template>
  <fieldset class="stripe-elements">
    <div id="payment-element" />
  </fieldset>
</template>

<script setup lang="ts"></script>

<style lang="scss">
.stripe-elements {
  .invalid-message {
    color: #f00;
    font-size: 12px;
  }
  .stripe-element {
    padding: 10px 18px;
  }
}
</style>
